import { Redirect, Route } from "react-router"
import { AdicionarContatoPage } from "../../../views/pages/adicionar-contato-page/adicionar-contato-page"
import { CadastrarPage } from "../../../views/pages/cadastrar-page/cadastrar-page"
import { ClientesPage } from "../../../views/pages/clientes-page/clientes-page"
import { LoginPage } from "../../../views/pages/login-page"
import { SaurusMobile } from "../../../views/pages/saurus-mobile/saurus-mobile"
import { SaurusPDV } from "../../../views/pages/saurus-pdv/saurus-pdv"
import { SaurusTouchOne } from "../../../views/pages/saurus-touchone/saurus-touchone"
import { SaurusV4 } from "../../../views/pages/saurus-v4/saurus-v4"
import { ScanQrCodePage } from "../../../views/pages/scan-qrcode-page/scan-qrcode-page"

export const RouterMain = () => {
    return (
        <div>
            <Route exact path="/saurus-pdv" component={SaurusPDV} />
            <Route exact path="/saurus-v4" component={SaurusV4} />
            <Route exact path="/saurus-mobile" component={SaurusMobile} />
            <Route exact path="/touchone" component={SaurusTouchOne} />
            <Route exact path="/representante/clientes" component={ClientesPage} />
            <Route exact path="/representante/adicionar-contato" component={AdicionarContatoPage} />
            <Route exact path="/representante/adicionar-contato/:id" component={AdicionarContatoPage} />
            <Route exact path="/representante/scan-qrcode" component={ScanQrCodePage} />

        </div>
    )
}